/* unplugin-vue-components disabled */import { render } from "./memory-editor.vue?vue&type=template&id=bcab6b7a&scoped=true"
import script from "./memory-editor.vue?vue&type=script&lang=js"
export * from "./memory-editor.vue?vue&type=script&lang=js"

import "./memory-editor.vue?vue&type=style&index=0&id=bcab6b7a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcab6b7a"],['__file',"src/pages/settings/memory/memory-editor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bcab6b7a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bcab6b7a', __exports__)) {
    api.reload('bcab6b7a', __exports__)
  }
  
  module.hot.accept("./memory-editor.vue?vue&type=template&id=bcab6b7a&scoped=true", () => {
    api.rerender('bcab6b7a', render)
  })

}


export default __exports__